/**
 * Animation state manager to prevent layout components from re-animating
 * on route changes after initial load
 */

const ANIMATION_STATE_KEY = 'td_layout_animations_complete';

export class LayoutAnimationManager {
  private static instance: LayoutAnimationManager;
  private animationComplete: boolean = false;

  private constructor() {
    // Check if animations have already completed in this session
    this.animationComplete = sessionStorage.getItem(ANIMATION_STATE_KEY) === 'true';
  }

  public static getInstance(): LayoutAnimationManager {
    if (!LayoutAnimationManager.instance) {
      LayoutAnimationManager.instance = new LayoutAnimationManager();
    }
    return LayoutAnimationManager.instance;
  }

  public hasCompleted(): boolean {
    return this.animationComplete;
  }

  public markComplete(): void {
    this.animationComplete = true;
    sessionStorage.setItem(ANIMATION_STATE_KEY, 'true');
  }

  public reset(): void {
    this.animationComplete = false;
    sessionStorage.removeItem(ANIMATION_STATE_KEY);
  }
}

// Hook for easy use in components
export const useLayoutAnimation = () => {
  const manager = LayoutAnimationManager.getInstance();
  
  return {
    hasCompleted: manager.hasCompleted(),
    markComplete: () => manager.markComplete(),
    reset: () => manager.reset(),
  };
};

export default LayoutAnimationManager;
